/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ils } from '../../models/ils';
import { UpdateIlsDto } from '../../models/update-ils-dto';

export interface IlsControllerUpdate$Params {
  ilsId: string;
      body: UpdateIlsDto
}

export function ilsControllerUpdate(http: HttpClient, rootUrl: string, params: IlsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ils>;
    })
  );
}

ilsControllerUpdate.PATH = '/ils/{ilsId}';
